import React from 'react';
import { Route } from 'react-router-dom';

// Define the shape of a single route object for TypeScript
interface RouteDefinition {
  path: string;
  element: React.ReactNode;
  children?: RouteDefinition[]; // Children are optional
}

/**
 * A recursive function that takes an array of route definitions
 * and maps them to React Router's <Route> components.
 * It handles nested routes by checking for a 'children' property.
 *
 * @param routes - An array of route definition objects.
 * @returns An array of JSX <Route> elements.
 */
export function renderRoutesFromArray(routes: RouteDefinition[]): React.ReactNode[] {
  return routes.map((route) => (
    <Route key={route.path} path={route.path} element={route.element}>
      {/*
        This is the core of the recursion: if the route object has a 'children' array,
        we call this same function again to render them INSIDE the parent Route.
      */}
      {route.children && renderRoutesFromArray(route.children)}
    </Route>
  ));
}
